module.exports = "//static.hsappstatic.net/ContentComponents/static-2.63389/img/DeepL-logo.png"